export default __webpack_public_path__ + "static/media/pin-skipped.4f690b97.svg";